import PropTypes from "prop-types";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
const PageHeader = ({ title, btn, subTitle, search }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1.5,
        p: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {btn.back && (
          <Button
            type="button"
            onClick={btn.back}
            sx={{
              mr: 1,
              p: 0.5,
              minWidth: "auto",
            }}
          >
            <ArrowBackIcon />
          </Button>
        )}
        <Typography variant="h6">
          {title}
          <Typography>{subTitle}</Typography>
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          ml: "auto",
        }}
      >
        {search && (
          <TextField
            size="small"
            value={search.value}
            onChange={(e) => search.onChange(e.target.value)}
            placeholder={search.placeholder || "Search"}
            sx={{
              minWidth: { xs: "100%", sm: 260 },
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" color="action" />
                </InputAdornment>
              ),
              endAdornment: search.value && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="clear search"
                    size="small"
                    onClick={() => search.onChange("")}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
        {/* {btn.btn1 && (
          <Button
            type="button"
            variant={btn.btn1Type}
            onClick={btn.btn1CallBack}
          >
            {btn.btn1Text}
          </Button>
        )} */}
        {btn.show && (
          <Button type="button" variant={btn.type} onClick={btn.callBack}>
            {btn.text}
          </Button>
        )}
      </Box>
    </Paper>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  btn: PropTypes.object,
  search: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
  }),
};

export default PageHeader;
